import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    // You can also log error messages to an error reporting service here

    console.log({ error, errorInfo });
  }

  render() {
    if (this.state.errorInfo) {
      // Error path
      return (
        <div style={{ padding: 50 }}>
          <h2>Something went wrong.</h2>
          <p style={{ whiteSpace: "pre-wrap" }}>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo.componentStack}
          </p>
        </div>
      );
    }
    // Normally, just render children
    return this.props.children;
  }
}
